import Vue from 'vue';
import Vuex from 'vuex';
import router from './router/index'
Vue.use(Vuex);

    //uploadUrl:"http://192.168.0.100/upload",
    //uploadUrl2:"http://192.168.0.100/",
    // [P194] ★ 环境自适应：上传地址不再硬编码环境域名。
    //   由 index.html 预加载的 static/config.js 中 window.config.serverIP 推导，
    //   使同一份产物在 cs7 / cs8 各自指向本环境 API（避免 cs7 上传打到 cs8）。
    //   兜底用「页面同源」，绝不写死某个环境。
    function _runtimeApiBase() {
      try {
        if (typeof window !== "undefined" && window.config && window.config.serverIP) {
          return String(window.config.serverIP)
        }
      } catch (e) { /* ignore */ }
      if (typeof window !== "undefined" && window.location && window.location.origin) {
        return window.location.origin + "/"
      }
      return ""
    }

    const state = {
      get uploadUrl() { return _runtimeApiBase() + "upload" },
      uploadUrl2:"",
      qiniupUrl:"https://upload-z2.qiniup.com/",
      qiniuSrcUrl:"https://gw.simpleappeal.cn/",
      // [P29/P30] 残留死配置 socket:"ws://<旧服务器IP>:33333" 已彻底删除（全项目无人引用）。
      //   WebSocket 地址统一由 src/util/websocket.js 的 buildWsUrl() 自推导：
      //   wss://<同主机>/ws（https 页面）经 nginx ws_proxy.conf 反代到 WorkerMan 127.0.0.1:33333。
      webURL:"http://localhost:8080/speaker",
      routeList: [] 
    };

    const mutations = {
      SET_ROUTE_LIST: (state, data) => {
          state.routeList = data
        }
    }

    const actions = {
      actUpdateRouteList({ commit }, data_list) {
         commit('SET_ROUTE_LIST', data_list)
      }
    }
    
    export default new Vuex.Store({
      state,
      mutations,
      actions
    });


// WEBPACK FOOTER //
// ./src/store.js